import { pick } from 'ramda';

export default pick(['reversed', 'start', 'type']);
